import React from 'react';
import QRCode from 'react-qr-code';

interface QRCodeDisplayProps {
    qrCode: string;
}

const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({ qrCode }) => {
    return (
        <div className="flex flex-col items-center justify-center h-screen p-4">
            <h2 className="text-xl font-semibold mb-4">Отсканируйте QR-код с помощью WhatsApp</h2>
            <div className="bg-white p-4 rounded shadow">
                <QRCode value={qrCode} size={256} />
            </div>
            <p className="mt-4 text-gray-600">Ожидание аутентификации...</p>
        </div>
    );
};

export default QRCodeDisplay;
